import * as React from "react";
import CardMedia from "@mui/material/CardMedia";
import { fetchBlobResource } from "@/apis/fetchResource";

export function useAuthenticatedImageUrl(src) {
    const [imageUrl, setImageUrl] = React.useState("");

    React.useEffect(() => {
        if (!src) {
            setImageUrl("");
            return;
        }

        const controller = new AbortController();
        let objectUrl;
        fetchBlobResource(src, { signal: controller.signal })
            .then(blob => {
                objectUrl = URL.createObjectURL(blob);
                setImageUrl(objectUrl);
            })
            .catch(error => {
                if (error.name !== "AbortError") console.error("Error loading authenticated image:", error);
            });

        return () => {
            controller.abort();
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [src]);

    return imageUrl;
}

export function AuthenticatedImage({ src, ...props }) {
    const imageUrl = useAuthenticatedImageUrl(src);
    // Rendering <img src=""> before the blob URL is ready makes the browser treat the
    // empty src as a request for the current page, firing a spurious onError before the
    // real image loads. Skip rendering the element entirely until there's a URL to show.
    if (!imageUrl) return null;
    return <img {...props} src={imageUrl} />;
}

export function AuthenticatedCardMedia({ src, fallbackImage, ...props }) {
    const imageUrl = useAuthenticatedImageUrl(src);
    return <CardMedia {...props} image={src ? imageUrl : fallbackImage} />;
}
